import api from "../api/api";

type Title24Arg = {
  glassAddon: string | null;
  doorType: string;
  material: string;
  glass: string;
  i89: string;
  stiles?: string;
  stileCategory?: string;
  liteConfig: string;
  breatherTubes: string;
  wood?: string;
  addScreen?: string;
  swingDirection?: string;
  sill?: string;
  addDL?: string;
  exactConfig?: string;
  alumThickFrame?: boolean;
};

async function findTitle24(title24Arg: Title24Arg) {
  const {
    glassAddon,
    doorType,
    material,
    glass,
    i89,
    stiles,
    stileCategory,
    liteConfig,
    breatherTubes,
    wood,
    addScreen,
    swingDirection,
    sill,
  } = title24Arg;

  if (glassAddon && glassAddon !== "Clear Lami") {
    return;
  }

  if(glass === "Clear"){
    return
  }

  const title24ParamsInCommon = {
    material,
    wood,
    glass,
    i89,
    stiles,
    liteConfig,
    breatherTubes,
    stileCategory,
    addScreen,
    alumThickFrame: title24Arg.alumThickFrame || false,
    glassAddon,
  };

  if (
    doorType.includes("Bi-fold") ||
    (doorType === "Fixed Panel" && title24Arg.exactConfig === "Fixed Bi-fold")
  ) {
    const res = await api.get("/api/title24", {
      params: {
        ...title24ParamsInCommon,
        sill,
        addDL: title24Arg.addDL,
      },
    });

    if (res.data.error) return "Error";

    return res.data;
  } else if (
    doorType === "Swing" ||
    doorType === "Pivot" ||
    (doorType === "Fixed Panel" &&
      (title24Arg.exactConfig === "Fixed Outswing" ||
        title24Arg.exactConfig === "Fixed Inswing"))
  ) {
    const swangD =
      doorType === "Pivot"
        ? "Inswing"
        : doorType === "Swing"
        ? swingDirection
        : title24Arg.exactConfig?.split(" ")[1];

    const stilesRails =
      doorType !== "Swing" && stileCategory === "Slimline"
        ? '2-1/2" Stiles and Rails with 3-7/16" Lock Stile'
        : stiles;

    const liteConfiguration =
      title24Arg.addDL === "Add Intermediate Rail" ? '1 1/8"' : liteConfig;

    const res = await api.get("/api/title24Swings", {
      params: {
        ...title24ParamsInCommon,
        swingDirection: swangD,
        stiles: stilesRails,
        addScreen,
        liteConfig: liteConfiguration,
      },
    });

    if (res.data.error) return "Error";

    return res.data;
  } else if (
    doorType === "Slider" ||
    (doorType === "Fixed Panel" && title24Arg.exactConfig === "Fixed Slider")
  ) {
    const stilesUsed =
      doorType === "Slider"
        ? stiles
        : !stileCategory?.includes("Slimline")
        ? stiles
        : '2-1/2" Stiles and Top Rails with 3-7/16" Lock Stile and Bottom Rails';

    const res = await api.get("/api/title24Sliders", {
      params: {
        ...title24ParamsInCommon,
        stiles: stilesUsed,
        addScreen,
        sillStyle: sill || "",
      },
    });

    if (res.data.error) return "Error";

    return res.data;
  }else if(doorType === "Fixed Panel" && title24Arg.exactConfig === "Fixed Full Bound"){
    const res = await api.get("/api/title24Fixed", {
      params: {
        ...title24ParamsInCommon
      },
    });

    if (res.data.error) return "Error";

    return res.data;
  }

  return { ufactor: "0.53", shgc: "0.53" };
}

export default findTitle24;
